export const isEmptyObject = (object) => {
  return (
    Object.values(object).includes(undefined) || Object.keys(object).length === 0
  )
}
